// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"78b71485","679":"9fcda3c7"}[chunkId] + ".chunk.js";
};